const DEFAULT_PRODUCTION_API_BASE_URL = 'https://api.algoreason.tech/api'

const splitEndpoint = (endpoint) => {
  const suffixIndex = endpoint.search(/[?#]/)

  if (suffixIndex === -1) {
    return { path: endpoint, suffix: '' }
  }

  return {
    path: endpoint.slice(0, suffixIndex),
    suffix: endpoint.slice(suffixIndex),
  }
}

const normalizeEndpointPath = (endpoint) => {
  const { path, suffix } = splitEndpoint(endpoint.trim())
  const pathWithLeadingSlash = path.startsWith('/') ? path : `/${path}`
  const publicPath = pathWithLeadingSlash.replace(/^\/api(?=\/|$)/, '') || '/'

  return { publicPath, suffix }
}

export const buildApiUrl = (
  endpoint,
  {
    isDevelopment = false,
    baseUrl = DEFAULT_PRODUCTION_API_BASE_URL,
  } = {},
) => {
  if (typeof endpoint !== 'string' || endpoint.trim() === '') {
    throw new TypeError('API endpoint must be a non-empty string')
  }

  const { publicPath, suffix } = normalizeEndpointPath(endpoint)
  // GKE serves API routes under /api in both development and production.
  const apiPath = publicPath === '/' ? '/api' : `/api${publicPath}`

  if (isDevelopment) {
    return `${apiPath}${suffix}`
  }

  const normalizedBaseUrl = String(baseUrl || DEFAULT_PRODUCTION_API_BASE_URL)
    .trim()
    .replace(/\/+$/, '')
    .replace(/\/api$/, '')

  return `${normalizedBaseUrl}${apiPath}${suffix}`
}

export const apiUrl = (endpoint, environment = import.meta.env) =>
  buildApiUrl(endpoint, {
    isDevelopment: environment?.DEV === true,
    baseUrl: environment?.VITE_API_BASE_URL,
  })

